/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
    <br>
  <div>
  <div class="formPosition">
           <v-card style="margin:auto;" width="1000px" >

              <template >

                  <v-toolbar color="#006699" style="color:white;">

            <v-row>
                    <v-col sm="4" cols="12" md="4">
                  </v-col>

                  <v-col sm="4" cols="12" md="6">  <!--  form titlte section   {{ formTitle }}-->
                <span style="font-size:20px;"> Definir Período / Prazos de Multa</span>

                  </v-col>

                    <v-col sm="4"  cols="12" md="2">

                  </v-col>

          </v-row>
                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>

                   <v-col  cols="12" md="12">
                      <v-combobox
                        v-model="mesSelected"
                        :rules="ruleRequired"
                        @change="loadData()"
                        item-value="id"
                        item-text="descricao"
                        :items="meses"
                        chips
                        label="Selecione o mês"
                      ></v-combobox>
                    </v-col>

                    <v-col  cols="12" md="6">
                      <template>
                      <v-menu
                        ref="menuMulta1"
                        v-model="menuMulta1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                         offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field

                            v-model="dataMulta1Selected"
                            :rules="[v => !!v || 'Campo obrigatorio!']"
                            label="Data da 1ª Multa"
                            :disabled="mesSelected === null"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            :max="maxYear"
                            :min="minYear"
                            v-model="dateMulta1"
                            @change="saveDateMulta1"
                          ></v-date-picker>
                        </v-menu>
                        </template>
                    </v-col>

                    <v-col  cols="12" md="6">
                      <template>
                      <v-menu
                        ref="menuMulta2"
                        v-model="menuMulta2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                         offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dataMulta2Selected"
                            :rules="[v => !!v || 'Campo obrigatorio!']"
                            label="Data da 2ª Multa"
                            prepend-icon="event"
                            :disabled="mesSelected === null"
                            readonly
                            v-on="on"
                          ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            :max="maxYear"
                            :min="minYear"
                            v-model="dateMulta2"
                            @change="saveDateMulta2"
                          ></v-date-picker>
                        </v-menu>
                        </template>
                    </v-col>

                    <v-col  cols="12" md="6">
                      <template>
                      <v-menu
                        ref="menuMulta3"
                        v-model="menuMulta3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                         offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field

                            v-model="dataMulta3Selected"
                            :rules="[v => !!v || 'Campo obrigatorio!']"
                            label="Data da 3ª Multa"
                            prepend-icon="event"
                            :disabled="mesSelected === null"
                            readonly
                            v-on="on"
                          ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            :max="maxYear"
                            :min="minYear"
                            v-model="dateMulta3"
                            @change="saveDateMulta3"
                          ></v-date-picker>
                        </v-menu>
                        </template>
                    </v-col>
                      <v-col md="6"></v-col>
                     <v-col md="5"></v-col>
                    <v-col md="2">
                        <v-btn    :disabled="!valid && novo"   color="success"    @click="save()">Submeter</v-btn>

                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

</v-form>

            </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    progresso: false,
    novo: false,
    valid: true,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    showFixos: false,
    data1Bd: '',
    data2Bd: '',
    data3Bd: '',
    cursos: [],
    classes: [],
    classesFiltered: [],
    tipoMultaSelected: null,
    menuMulta1: false,
    dateMulta1: false,
    dataMulta1Selected: null,
    menuMulta2: false,
    dateMulta2: false,
    dataMulta2Selected: null,
    menuMulta3: false,
    dateMulta3: false,
    dataMulta3Selected: null,
    percentual1: 0,
    percentual2: 0,
    percentual3: 0,
    fixo1: 0,
    fixo2: 0,
    fixo3: 0,
    isLoading: false,
    servico: '',
    cor: '',
    maxYear: '2025-12-31',
    minYear: '1950-01-01',
    searchInDb: '',
    mesSelected: null,
    cursoSelected: null,
    preco: 0,
    servicos: [],
    multasExistentes: [],
    servicosTabela: [],
    valorFormatado: '',
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    meses:
    [
      { id: '01', descricao: 'Janeiro' },
      { id: '02', descricao: 'Fevereiro' },
      { id: '03', descricao: 'Março' },
      { id: '04', descricao: 'Abril' },
      { id: '05', descricao: 'Maio' },
      { id: '06', descricao: 'Junho' },
      { id: '07', descricao: 'Julho' },
      { id: '08', descricao: 'Agosto' },
      { id: '09', descricao: 'Setembro' },
      { id: '10', descricao: 'Outubro' },
      { id: '11', descricao: 'Novembro' },
      { id: '12', descricao: 'Dezembro' }
    ],
    //  timeout: 4000,
    tipoMulta:
    [
      { id: 1, descricao: 'Percentual' },
      { id: 2, descricao: 'Fixo' }
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    headers: [
      {
        text: 'Mês',
        align: 'left',
        sortable: false,
        value: 'mes'
      },

      { text: 'Data Multa 1', value: 'data1' },
      { text: 'Data Multa 2', value: 'data2' },
      { text: 'Data Multa 3', value: 'data3' },
      { text: 'Autor', value: 'autor' },
      { text: 'data cadastro', value: 'data_' }
    ],
    msg: '',
    editedIndex: -1

  }),

  computed: {

    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuMulta1 (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'MONTH'))
    },
    menuMulta2 (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuMulta3 (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    dialog (val) {
      val || this.close()
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    // this.initializeServicos()
    this.SetMaxYear()
    this.SetMinYear()
    this.initializeCursos()
    this.initializeClasses()
    this.initializePrazosMulta()
  },

  methods: {
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL

    async initializePrazosMulta () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.servicos = await axios
          .get('/PrazoMultasFindAll')
          .then(res => res.data)
        console.log(this.servicos)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        console.log(this.cursos)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeClasses () {
      try {
        this.isLoading = true
        this.classes = await axios
          .get('/classeFindAll')
          .then(res => res.data)
        console.log(this.classes)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    SelectMulta () {
      if (this.tipoMultaSelected.id === 1) { this.showFixos = false } else if (this.tipoMultaSelected.id === 2) { this.showFixos = true }
    },

    loadclasse () {
      this.classesFiltered = this.classes.filter(c => c.fk_curso === this.cursoSelected.pk_curso)
    },

    chamaDialogo () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      this.valorFormatado = formated.toString().replace('AOA', '')
    },

    SetMaxYear () {
      this.maxYear = '2022' + '-12-01'
    },

    SetMinYear () {
      this.minYear = '2000' + '-01-01'
    },

    loadData () {
      if (this.mesSelected !== null) {
        this.maxYear = '2022' + '-' + this.mesSelected.id + '-31'
        this.minYear = '2000' + '-' + this.mesSelected.id + '-01'
      }
    },

    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true
        let params =
          {
            pk_definir_multa: 0,
            idMes: parseInt(this.mesSelected.id),
            dataMulta1: this.data1Bd,
            dataMulta2: this.data2Bd,
            dataMulta3: this.data3Bd
          }
        let paramsTabela =
          {
            mes: this.mesSelected.descricao,
            data1: this.dataMulta1Selected,
            data2: this.dataMulta2Selected,
            data3: this.dataMulta3Selected,
            autor: ls.get('nomeUsuario')
          }
        try {
          let corMensagem = 'msgError'
          let msg = await axios
            .post('/definirMultaInsertOrUpdate', params)
            .then(res => res.data)
          this.progresso = false

          if (msg.length) {
            corMensagem = 'msgError'
            this.text = 'Ocorreu um erro ao tentar efectuar a operação'
          } else {
            corMensagem = 'msgSucess'
            this.text = 'Operação efectuada com sucesso'
            this.servicosTabela.unshift(paramsTabela)
            this.close()
          }
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 5000 })
        } catch (error) {
          this.progresso = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },
    saveDateMulta1 (dateMulta1) {
      let data1 = new Date(dateMulta1)
      this.$refs.menuMulta1.save(data1.toISOString().substr(5, 5))
      this.dataMulta1Selected = data1.toISOString().substr(5, 5)
      this.data1Bd = dateMulta1

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(dateMulta1).toISOString().substr(0, 10)
    },
    saveDateMulta2 (dateMulta2) {
      let data2 = new Date(dateMulta2)
      this.$refs.menuMulta2.save(data2.toISOString().substr(5, 5))
      this.dataMulta2Selected = data2.toISOString().substr(5, 5)
      this.data2Bd = dateMulta2
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(dateMulta2).toISOString().substr(0, 10)
    },
    saveDateMulta3 (dateMulta3) {
      let data3 = new Date(dateMulta3)
      this.$refs.menuMulta3.save(data3.toISOString().substr(5, 5))
      this.dataMulta3Selected = data3.toISOString().substr(5, 5)
      this.data3Bd = dateMulta3
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(dateMulta3).toISOString().substr(0, 10)
    },
    async initializeMultas () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.multasExistentes = await axios
          .get('/definirMultasExistente')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }

  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
